/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { Item } from './types'

const Dropdown = ({ list, addItem }: { list: Item[]; addItem: (args: Item) => void }) => {
  return (
    <div
      id="dropdown"
      className="absolute overflow-y-auto bg-white rounded shadow top-100 lef-0 max-h-select z-100 w-80"
    >
      <div className="flex flex-col w-full">
        {list.map((item: Item) => {
          return (
            <div
              key={item.value}
              className="w-full border-b border-gray-100 rounded-t cursor-pointer hover:text-white hover:bg-primary"
              onClick={() => addItem(item)}
            >
              <div className="relative flex items-center w-full p-1 pl-1 border-transparent">
                <div className="flex items-center w-full">
                  <div className="mx-2 text-xs leading-5">{item.label}</div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Dropdown
